import React, {useContext, useEffect, useRef} from 'react';
import {AppContext} from '../contexts/context';

// Components
import ScanDialog from './ScanDialog'
import DataDisplay from '../components/DataDisplay'
import AppSnackbar from './AppSnackbar';
import { AttentionCard } from './cards/AttentionCard';
import { WarningCard } from './cards/WarningCard';
import { AppInfoCard } from './cards/AppInfoCard';
import { AppInstallableCard } from './cards/AppInstallableCard';
import { AppOpenCard } from './cards/AppOpenCard';
import { AppRepairDataCard } from './cards/AppRepairDataCard';
import { AppUpdateCard } from './cards/AppUpdateCard';
import { NfcNotAvailableCard } from './cards/NfcNotAvailableCard';
import { NfcNotGrantedCard } from './cards/NfcNotGrantedCard';
import { UseIosCard } from './cards/UseIosCard';
import { DemoModeCard } from './cards/DemoModeCard';
import DataExchangeFab from './DataExchangeFab';

// Material UI
import {makeStyles} from '@mui/styles';
import {useCountDataKeys, useCountImportedValues} from "./AppUtils";
import {Capacitor} from "@capacitor/core";

const useStyles = makeStyles((theme) => ({
  card: {
    margin: 10,
    paddingBottom: 0,
  },
  button: {
    marginRight: 10,
  },
  snackbar: {
    /* [theme.breakpoints.down('xs')]: {
      bottom: 90,
    }, */
  },
}));

function DataPage(props) {
  const classes = useStyles();
  const [ state, dispatch ] = useContext(AppContext);
  const importedParams = useCountImportedValues();
  const changedParams = useCountDataKeys();

  // Scan dialog mode switch
  const scanDialogModeSwitchRef = useRef(state.scanDialogModeSwitch);
  useEffect(() => {
    scanDialogModeSwitchRef.current = state.scanDialogModeSwitch;
  }, [state.scanDialogModeSwitch]);

  // console.debug("DataPage: Re-Render ...")

  const onDataExchangeActionFab = () => {
    // Open scan dialog
    dispatch({type: 'app/ui/dialog/ndef/show', value: true})
    dispatch({type: 'ndef/scan/scanning'});

    // Decide if data should be written or read to/from devide
    console.debug("ScanDialog | Check against new read with changed parameters");
    switch(state.deviceData.source) {
      case 'unknown':
      case 'app':
      case 'scan':
      case 'demo':
        if(changedParams > 0 || state.deviceData.scanTime !== "unknown") {
          dispatch({type: 'app/ui/scanDialog/modeSwitch/available'});
          // Switch between read and write
          console.warn("ScanDialog | Switch between read and write");
          dispatch({type: 'ndef/control/idle'});
        } else {
          dispatch({type: 'ndef/control/reading'});
          dispatch({type: 'app/ui/scanDialog/modeSwitch/unavailable'});
        }
        break;
      case 'import':
        //Enable Write
        console.warn("ScanDialog | Enable Write");
        dispatch({type: 'ndef/control/writing'});
        dispatch({type: 'app/ui/scanDialog/writeInitializer', value: importedParams})
        dispatch({type: 'app/ui/scanDialog/modeSwitch/unavailable'});
        break;
      default:
        throw new Error("ScanDialog | Unknown device source: " + state.deviceData.source);
    }
  }

  const handleAbortClick = () => {
    console.debug('handleAbortClick')
    // If scan dialog is idle or there is no mode switch, close scan dialog.
    if (state.ndefControl === "idle" || !scanDialogModeSwitchRef.current) {
      dispatch({type: 'app/ui/dialog/ndef/show', value: false})
    }
    // Always switch back to idle
    dispatch({type: 'ndef/control/idle'});
  }

  const handleComfirmationClick = () => {
    console.debug('handleComfirmationClick')
    dispatch({type: 'app/ui/dialog/ndef/show', value: false})
    dispatch({type: 'ndef/control/idle'});
  }

  const handlRetryClick = () => {
    console.debug('handlRetryClick')
    // dispatch({type: 'ndef/control/setForNewRead'});
    dispatch({type: 'app/ui/dialog/ndef/show', value: false})
    dispatch({type: 'app/ui/dialog/ndef/show', value: true})
    dispatch({type: 'ndef/control/reading'});
  }

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

  // Home screen: no data scanned/imported yet (or repair data). Once the form is
  // shown, the demo mode hint moves to the app bar icon (see DemoModeDialog).
  const isHomeScreen = Object.keys(state.deviceData.schema).length <= 0 || state.deviceData.schema.$id === "/schemas/Repair/v1.0.0"

  return (
    <>
      {state.settingDemoMode && isHomeScreen && (
        <div style={{marginInline:10, marginTop:10, display:"flex", flexDirection:"column"}}>
          <DemoModeCard/>
        </div>
      )}
      {isHomeScreen
        ? <div style={{marginInline:10, marginBlock:10, display:"flex", gap:10, flexDirection:"column"}}>
            <AppInfoCard/>
            {isSafari || Capacitor.getPlatform() === 'ios'?'':<WarningCard/>}
            {state.uiCardNfcNotAvailable === 'show'
              ? (isSafari ? <UseIosCard/> : <NfcNotAvailableCard/>)
              : state.uiCardNfcNotGranted === 'show'
                ? <NfcNotGrantedCard/>
                : state.deviceData.schema.$id === "/schemas/Repair/v1.0.0"
                  ? <AppRepairDataCard/>
                  : <AttentionCard Title={"Getting started"} Text={`Press the DATA EXCHANGE button to start the contactless reading of data.`} grantHandler={props.grantHandler}/>
            }
            {state.uiCardAppInstallable === 'show' && !isSafari
              ? <AppInstallableCard/>
                : state.uiCardAppOpen === 'show' && !isSafari
                  ? <AppOpenCard/>
                  : ''
            }
            {state.appSwUpdated === true
              ? <AppUpdateCard/>
              : <></>
            }
          </div>
        : ''
      }
      {(Object.keys(state.deviceData.schema).length > 0 && state.ndefControl === 'idle' && state.deviceData.schema.$id !== "/schemas/Repair/v1.0.0") && (
        <DataDisplay />
      )}

      {state.uiScanDialog?
        <ScanDialog
          abortHandler={handleAbortClick}
          retryHandler={handlRetryClick}
          confirmHandler={handleComfirmationClick}
        /> :
        <div></div>
      }

      {!isSafari?<DataExchangeFab onClick={onDataExchangeActionFab}/> :''}
      <AppSnackbar
        classes={classes.snackbar}
      />
    </>
  )
}

export default DataPage;
